




















































































import Vue from 'vue';
import Vuex from 'vuex';

import Axios from 'axios';

import { MDCTextField } from '@material/textfield';
import { MDCRipple } from '@material/ripple';
import { MDCSnackbar } from '@material/snackbar';

import AuthManager, { LoginResponse } from '../libs/authentication';

interface Data {
  login: string;
  password: string;

  register: boolean;
  loginError: boolean;

  snackbar: MDCSnackbar;
}

export default Vue.extend({
  name: 'login',
  data(): Data {
    return {
      login: '',
      password: '',
      register: false,

      loginError: false,
    } as Data;
  },
  // redirect to root if allready authenticated
  beforeCreate() {
    if (this.$store.getters.isAuth()) {
      this.$router.push('/');
    }
  },
  mounted() {
    this.finalRender();
  },
  updated() {
    this.finalRender();
  },
  destroyed() {
    this.snackbar.destroy();
  },
  methods: {
    submit() {
      const v = this;
      Axios.post('/API/login', {
        login: this.login,
        pass: this.password,
        register: this.register,
      })
        .then((response: any) => {
          const data: LoginResponse = response.data;
          v.loginError = false;
          AuthManager.setAuth(this, true, data.Admin, data.Token);

          window.localStorage.setItem('login', this.login);

          v.$router.push(v.$route.hash.substring(1));
          document.location.reload();

        }).catch((err: any) => {
          console.warn(err);

          v.loginError = true;

          v.snackbar.open();
        });
    },
    toggleRegister() {
      this.register = !this.register;
    },
    finalRender() {
      let elements = document.querySelectorAll('.mdc-text-field');
      for (let i = 0; i < elements.length; i++) {
        const tmp = new MDCTextField(elements.item(i));
      }
      elements = document.querySelectorAll('.mdc-button');
      for (let i = 0; i < elements.length; i++) {
        const tmp = new MDCRipple(elements.item(i));
      }

      const snackbareElem = document.querySelector('.mdc-snackbar.login');
      if (snackbareElem === null) {
        return;
      }
      this.snackbar = new MDCSnackbar(snackbareElem);
    },
  },
});
